//#region themes/config.js
function e(e, r = document.documentElement) {
	n(e.base.name, e.brand.name, r), r?.shadowRoot && (r = r.shadowRoot), t("dialtone-css-theme", e.base.css, r), t("dialtone-css-brand", e.brand.css, r);
}
function t(e, t, n) {
	if (n.querySelector("#" + e)) n.querySelector("#" + e).innerHTML = t;
	else {
		let r = document.createElement("style");
		r.setAttribute("type", "text/css"), r.setAttribute("id", e), r.innerHTML = t, n.querySelector("head") ? n.querySelector("head").appendChild(r) : n.appendChild(r);
	}
}
function n(e, t, n) {
	n.setAttribute("data-dt-theme", e), n.setAttribute("data-dt-brand", t);
}
//#endregion
export { e as setTheme };
